import config from './';

const clientId = 'f54cb44e85014aac81808979042360b9';

const authorizationBaseUrl = 'https://accounts.spotify.com/authorize';

const scopes = ['playlist-read-private', 'user-library-read', 'user-top-read'];

export const xsrfBust = '34fFs29kd09';

let authorizationUrl = '';
authorizationUrl += authorizationBaseUrl;
authorizationUrl += '?client_id=';
authorizationUrl += clientId;
authorizationUrl += '&response_type=code';
authorizationUrl += '&redirect_uri=';
authorizationUrl += encodeURIComponent(
  `${config.appBaseUrl}spotify-authorization/callback`
);
authorizationUrl += `&scope=${scopes.join(' ')}`;
authorizationUrl += `&state=${xsrfBust}`;

export const spotifyAuthorizationUrl = authorizationUrl;

export const timeElapsedBeforeNextAccessPrompt = 24 * 60 * 60 * 1000;
